'use strict';

module Patersons {

    export class CashReport extends AbstractReport {
        transactionGroups: CashReportTransactionGroup[];
    }

    export class CashReportTransactionGroup {
        name: string;
        transactions: CashReportLineItem[];
        closingBalance: CashReportLineItem;
    }

    export class CashReportLineItem {
        date: Date;
        description: string;
        debit: number;
        credit: number;
        balance: number;
        cashSecurityGroupName: string;
    }

    export class CashReportComponent implements ng.IComponentOptions {
        templateUrl: string = 'assets/templates/portfolioSummary/components/cashReport.component.html';
        controller: any = CashReportController;
        bindings: any = {
            report: '<',
            title: '@'
        };
    }

    export class CashReportController extends AbstractReportController {
        report: CashReport;
    }

}

